import Config from "../_config/config";
import myAxios from "./axiositeachWrapper";

const BASE = `${Config.nodeSiteUrl}v1/grade-cards`;

class GradeCardService {
  // Rating scales
  listRatingScales = () => myAxios.get<any>(`${BASE}/rating-scales`);
  saveRatingScale = (body: Record<string, any>) =>
    myAxios.post<any>(`${BASE}/rating-scales`, body);

  // Structure templates
  listStructures = (params?: { programId?: number }) =>
    myAxios.get<any>(`${BASE}/structures`, { params });
  getStructure = (id: number) =>
    myAxios.get<any>(`${BASE}/structures/${id}`);
  createStructure = (body: Record<string, any>) =>
    myAxios.post<any>(`${BASE}/structures`, body);
  updateStructure = (id: number, body: Record<string, any>) =>
    myAxios.put<any>(`${BASE}/structures/${id}`, body);
  deleteStructure = (id: number) =>
    myAxios.delete<any>(`${BASE}/structures/${id}`);
  cloneStructure = (id: number) =>
    myAxios.post<any>(`${BASE}/structures/${id}/clone`);

  // Teacher data entry
  getStudentsForEntry = (params: {
    batchId: number;
    structureId: number;
    termIndex?: number;
    yearId?: number;
  }) => myAxios.get<any>(`${BASE}/entry/students`, { params });

  getStudentEntries = (
    enquiryId: number,
    params: { structureId: number; yearId?: number },
  ) => myAxios.get<any>(`${BASE}/entry/${enquiryId}`, { params });

  saveEntries = (body: {
    enquiryId: number;
    enrollmentId?: number;
    structureId: number;
    termIndex: number;
    yearId?: number;
    remarks?: string;
    entries: Array<{ itemId: number; value: string | null }>;
  }) => myAxios.post<any>(`${BASE}/entry/save`, body);

  publishGradeCard = (body: {
    cardId?: number;
    enquiryId?: number;
    structureId?: number;
    termIndex?: number;
    yearId?: number;
  }) => myAxios.post<any>(`${BASE}/entry/publish`, body);

  unpublishGradeCard = (body: {
    cardId?: number;
    enquiryId?: number;
    structureId?: number;
    termIndex?: number;
    yearId?: number;
  }) => myAxios.post<any>(`${BASE}/entry/unpublish`, body);

  // Student view
  getStudentGradeCard = (params?: { enquiryId?: number }) =>
    myAxios.get<any>(`${BASE}/for-student`, { params });
}

export default new GradeCardService();
